import { css } from "../../../../../styled-system/css";

export const styles = {
  divPoint: () =>
    css({
      width: "100%",
      textAlign: "center",
      padding: 0,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      mobile: {
        alignItems: "center",
      },
    }),

  icon: () =>
    css({
      width: "72px",
      height: "72px",
      margin: "0 auto",
    }),

  image: () =>
    css({
      maxWidth: "344px",
      margin: "0 auto",
    }),

  title: () =>
    css({
      marginTop: "baseUnit.mobile2",
      fontWeight: 500,
      fontSize: "heading.H4.mobile",
      lineHeight: "heading.H4.mobile",
      textAlign: "center",
      width: "100%",
      marginBottom: "baseUnit.mobile4",
    }),

  text: () =>
    css({
      textAlign: "center",
      width: "100%",
      margin: 0,
      padding: 0,
    }),
};
